import httpClient, {
  ApiResponseType,
  CreateResourceSuccessResponseType,
  FORM_DATA_CONFIG,
} from '../../http_client';
import {
  GetIncentiveAgreement,
  GetIncentiveAgreementResponse,
  UpdateCreateIncentiveAgreementType,
  UpdateIncentiveAgreementResponse,
} from '../types';
import { convertIncentiveAgreementBody, STARTUP_INCENTIVE_AGREEMENT } from '../utils';

const getStartupIncentiveAgreementByIdApi = (id: number) => {
  const url = `${STARTUP_INCENTIVE_AGREEMENT}/${id}`;
  return httpClient.get<ApiResponseType<GetIncentiveAgreement>>(url);
}

const createStartupIncentiveAgreementApi = (data: UpdateCreateIncentiveAgreementType) => {
  const url = STARTUP_INCENTIVE_AGREEMENT;
  const body = convertIncentiveAgreementBody(data);
  return httpClient.post<ApiResponseType<CreateResourceSuccessResponseType>>(url, body, FORM_DATA_CONFIG);
}

const updateStartupIncentiveAgreementApi = (data: UpdateCreateIncentiveAgreementType, id: number) => {
  const url = `${STARTUP_INCENTIVE_AGREEMENT}/${id}`;
  const body = convertIncentiveAgreementBody(data);
  return httpClient.put<ApiResponseType<UpdateIncentiveAgreementResponse>>(url, body, FORM_DATA_CONFIG);
}

export const getStartupIncentiveAgreementById = async (id: number): Promise<GetIncentiveAgreementResponse> => {
  const response = await getStartupIncentiveAgreementByIdApi(id);
  const { data, error, httpStatus } = response;
  return { error, httpStatus, data: data?.result };
}

export const createStartupIncentiveAgreement = async (data: UpdateCreateIncentiveAgreementType):
  Promise<ApiResponseType<CreateResourceSuccessResponseType>> => {
  const response = await createStartupIncentiveAgreementApi(data);
  const { error, httpStatus } = response;
  return { error, httpStatus };
}

export const updateStartupIncentiveAgreement = async (payload: UpdateCreateIncentiveAgreementType, id: number):
  Promise<ApiResponseType<CreateResourceSuccessResponseType>> => {
  const response = await updateStartupIncentiveAgreementApi(payload, id);
  const { error, httpStatus } = response;
  return { error, httpStatus };
}
